// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

.account-nav_user-info_AH1XY {
    display: inline-flex;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
    align-content: center;
    padding: 0 0.95rem;
    max-width: 260px;
    height: 3rem;
    overflow: hidden;
    text-decoration: none;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: .75rem;
    font-weight: normal;
}

[dir="ltr"] .account-nav_user-info_AH1XY .account-nav_avatar_tKNh8 {
    margin-right: calc(0.5rem * .8125);
}

[dir="rtl"] .account-nav_user-info_AH1XY .account-nav_avatar_tKNh8 {
    margin-left: calc(0.5rem * .8125);
}

.account-nav_user-info_AH1XY .account-nav_avatar_tKNh8 {
    width: 2rem;
    height: 2rem;
}

.account-nav_user-info_AH1XY .account-nav_thumbnail_sjhou {
    border-radius: calc(0.5rem / 2);
    box-shadow: 0 0 0 1px var(--ui-black-transparent);
}

[dir="ltr"] .account-nav_user-info_AH1XY .account-nav_dropdown-caret-position_f_Fuq {
  margin-left: calc(0.5rem * .8125);
}

[dir="rtl"] .account-nav_user-info_AH1XY .account-nav_dropdown-caret-position_f_Fuq {
  margin-right: calc(0.5rem * .8125);
}

.account-nav_user-info_AH1XY .account-nav_dropdown-caret-position_f_Fuq {
  display: inline-block;
  padding-bottom: .0625rem;
  vertical-align: middle;
}

.account-nav_user-info_AH1XY .account-nav_profile-name_SpuLp {
    font-size: .75rem;
    line-height: .9375rem;
    font-weight: bold;
}
`, "",{"version":3,"sources":["webpack://./src/components/menu-bar/account-nav.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;sDACsD;;AAEtD,+CAA+C;;AAE/C;IACI,oBAAoB;IACpB,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,qBAAqB;IACrB,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,+BAA+B;IAC/B,iDAAiD;AACrD;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;IACrB,iBAAiB;AACrB","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\n.user-info {\n    display: inline-flex;\n    flex-wrap: nowrap;\n    justify-content: center;\n    align-items: center;\n    align-content: center;\n    padding: 0 0.95rem;\n    max-width: 260px;\n    height: 3rem;\n    overflow: hidden;\n    text-decoration: none;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    font-size: .75rem;\n    font-weight: normal;\n}\n\n[dir=\"ltr\"] .user-info .avatar {\n    margin-right: calc(0.5rem * .8125);\n}\n\n[dir=\"rtl\"] .user-info .avatar {\n    margin-left: calc(0.5rem * .8125);\n}\n\n.user-info .avatar {\n    width: 2rem;\n    height: 2rem;\n}\n\n.user-info .thumbnail {\n    border-radius: calc(0.5rem / 2);\n    box-shadow: 0 0 0 1px var(--ui-black-transparent);\n}\n\n[dir=\"ltr\"] .user-info .dropdown-caret-position {\n  margin-left: calc(0.5rem * .8125);\n}\n\n[dir=\"rtl\"] .user-info .dropdown-caret-position {\n  margin-right: calc(0.5rem * .8125);\n}\n\n.user-info .dropdown-caret-position {\n  display: inline-block;\n  padding-bottom: .0625rem;\n  vertical-align: middle;\n}\n\n.user-info .profile-name {\n    font-size: .75rem;\n    line-height: .9375rem;\n    font-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
var _1 = `account-nav_user-info_AH1XY`;
export { _1 as "user-info" };
export var userInfo = `account-nav_user-info_AH1XY`;
export var avatar = `account-nav_avatar_tKNh8`;
export var thumbnail = `account-nav_thumbnail_sjhou`;
var _2 = `account-nav_dropdown-caret-position_f_Fuq`;
export { _2 as "dropdown-caret-position" };
export var dropdownCaretPosition = `account-nav_dropdown-caret-position_f_Fuq`;
var _3 = `account-nav_profile-name_SpuLp`;
export { _3 as "profile-name" };
export var profileName = `account-nav_profile-name_SpuLp`;
export default ___CSS_LOADER_EXPORT___;
